import { useDebouncedCallback } from '@core-web/hooks';
import * as S from './ModalButton.styled';

export interface IModalButtonProps {
  title: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'danger' | 'success' | 'outline-light';
}

export const ModalButton = (props: IModalButtonProps): JSX.Element => {
  const { title, onClick, disabled, variant } = props;

  const clickHandler = useDebouncedCallback((e: React.MouseEvent<HTMLElement>) => {
    if (disabled) return;
    onClick();
  }, 300);

  return (
    <S.ModalButton onClick={clickHandler} disabled={props.disabled} className={variant ? variant : 'success'}>
      {title}
    </S.ModalButton>
  );
};
